import {classNames, Fragment} from '@api'
import {useStores} from '@modules'
import {usePdfStore} from '@modules/pdf'
import {React} from '@api';
import {DrawerBody, DrawerFooter} from 'centric-ui-components'
import {Drawer, Button, FormGroup, Tooltip} from '@material-ui/core'
import {observer} from '@api'
import {SideBarItem} from './SideBarItem'
import * as css from './PdfSidebar.css'

export const PdfSidebar = observer<{className?: string}>(function PdfSideBar({className}) {
  // const { classes } = props;

  const {catalog: {isShowingClientPDF, sidebar: {right: {open}}}} = useStores()
  return (
    <Drawer
      className={classNames(css.pdf, className)}
      variant="permanent"
      open={isShowingClientPDF && open}
      // classes={{
      // paper: classes.drawerPaper,
      // root: css.pdfpaper
      // }}
      anchor="right"
    >
      <PdfSidebarContent />
    </Drawer>
  )
})

export const PdfSidebarContent = observer(function PdfSidebarContent() {
  const confSections = ['document', 'page', 'sections'],
    {undo: {config, rollback, isDirty, commit}} = usePdfStore()

  DEBUG && confSections.push('datasource')

  return (<Fragment>
      <DrawerBody classes={{drawerContent: classNames(css.drawerContent, css.drawerFooter)}}>
        {config && confSections.map(confType => (
          <SideBarItem key={confType} type={confType}/>
        ))}
      </DrawerBody>
      {false && <DrawerFooter classes={{footerContent: css.drawerFooter}}>
	      <FormGroup row className={css.footer}>
            {/*<Tooltip2 content="Prevent PDF from">
            <AnchorButton className={css.button} disabled={!pdf?.query?.data} active={pdf.isFrozen} icon='snowflake' onClick={toggleFreeze} minimal>Freeze</AnchorButton>
          </Tooltip2>*/}
		      <Button className={css.button} onClick={rollback}>Cancel</Button>
		      <Button disabled={!isDirty} className={css.button} color="secondary" onClick={commit}>
			      Apply
		      </Button>
	      </FormGroup>
      </DrawerFooter>}
    </Fragment>)
})


// WEBPACK FOOTER //
// ./src/modules/pdf/sideBar/PdfSidebar.tsx